var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barrery-outer"},[_c('div',{staticClass:"batteryCompartment"},_vm._l((_vm.list),function(i){return _c('div',{key:i,staticClass:"batteryOuter"},[_c('div',{staticClass:"batteryText"},[_vm._v(_vm._s(i.name))]),_c('div',{staticClass:"batteryValue"},[_vm._v(_vm._s(i.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }